import { Heading } from '@hhgtech/hhg-components'
import {
  Avatar,
  Button,
  Text,
  themeColors,
} from '@hhgtech/hhg-components/mantine'
import { Box, Card, Flex, Stack } from '@mantine/core'
import { useIntl } from 'react-intl'

import { useIsMobile } from 'hooks/useIsMobile'
import { assetImagePath } from 'interfaces/constants'
import { ExpertUserSummary } from 'interfaces/types'

type Props = {
  expert: ExpertUserSummary
}

const ExpertAuthorCard = ({ expert }: Props) => {
  const { formatMessage: f } = useIntl()
  const isMobile = useIsMobile()
  return (
    <Card
      padding={8}
      pb={22}
      radius={16}
      sx={{
        border: `2px solid ${themeColors.neutral[0]}`,
      }}
    >
      <Flex gap={24}>
        <div>
          <Avatar
            src={expert.avatarThumbnail}
            withIndicator
            indicatorConfig={{
              size: 18,
              label: (
                <img
                  loading="lazy"
                  width="18"
                  height="18"
                  src={`${assetImagePath}/article-${expert.role}.svg`}
                  alt=""
                />
              ),
            }}
          />
        </div>

        <Stack spacing={8} w="100%" pr={14}>
          <Flex justify={'space-between'} align={'center'}>
            <Heading tag="h5">{expert.displayName}</Heading>
            {!isMobile && (
              <Button
                variant="ghost"
                size="sm"
                compact
                rightIcon={
                  <svg width="19" height="18" viewBox="0 0 19 18" fill="none">
                    <path
                      d="M7.45117 13.5L11.9512 9L7.45117 4.5"
                      stroke="#2D87F3"
                      stroke-width="1.75"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                }
              >
                <a href={expert.profileUrl}>
                  {f({
                    id: 'expert.content.readMore',
                    defaultMessage: 'View Profile',
                  })}
                </a>
              </Button>
            )}
          </Flex>
          {(expert?.organisation || expert?.specialty) && (
            <Box
              component={expert?.organisationUrl ? 'a' : 'span'}
              href={expert?.organisationUrl}
              {...(expert?.organisationUrl && {
                target: '_blank',
              })}
            >
              <Text size="n1" color={themeColors.gray[6]}>
                <span
                  dangerouslySetInnerHTML={{
                    __html: `${expert?.specialty && expert?.specialty}${
                      expert.organisation
                        ? ` · <span style='text-decoration: underline'>${expert.organisation}</span>`
                        : ''
                    }`,
                  }}
                ></span>
              </Text>
            </Box>
          )}
          <Text size="p4" lineClamp={2} color={themeColors.gray[4]}>
            <span
              dangerouslySetInnerHTML={{ __html: expert.description }}
            ></span>
          </Text>
          {isMobile && (
            <Button
              variant="ghost"
              size="sm"
              compact
              w="fit-content"
              rightIcon={
                <svg width="19" height="18" viewBox="0 0 19 18" fill="none">
                  <path
                    d="M7.45117 13.5L11.9512 9L7.45117 4.5"
                    stroke="#2D87F3"
                    stroke-width="1.75"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              }
              p={0}
            >
              <a href={expert.profileUrl}>
                {f({
                  id: 'expert.content.readMore',
                  defaultMessage: 'View Profile',
                })}
              </a>
            </Button>
          )}
        </Stack>
      </Flex>
    </Card>
  )
}

export { ExpertAuthorCard }
